import React from 'react'
import PropTypes from 'prop-types'
import StatusReportStatusIcon from './StatusReportStatusIcon'

function StatusDisplay ({ statusInfo, size, useIcon, hasBackground }) {
  return (
    <StatusReportStatusIcon
      statusId={statusInfo?.statusId}
      status={statusInfo}
      size={size}
      useIcon={useIcon}
      hasBackground={hasBackground}
    />
  )
}

StatusDisplay.propTypes = {
  statusInfo: PropTypes.object,
  size: PropTypes.number,
  useIcon: PropTypes.bool,
  hasBackground: PropTypes.bool
}

StatusDisplay.defaultProps = {
  size: 14,
  useIcon: false,
  hasBackground: true
}

export default StatusDisplay
